export class MemberData {
    title:String;
    position:String;
    description:String;
    imageUrl:String;
    id:String;
    subSectionName:String;
    sectionId:String;
    orderOfDisplay:String
}